import { ChangeDetectorRef, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ItemService } from 'src/app/services/item.service';
import { ItemSimilar } from 'src/app/persistences/item-similar';
import { mergeMap } from 'rxjs/operators';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { NumberUtils } from 'src/app/utils/utils/number-utils';
import { JwtService } from 'src/app/jwt.service';
import { CurrencyPipe } from '@angular/common';
import { SnackbarManager } from './../../managers/snackbar-manager';
import { Cliente } from 'src/app/persistences/cliente';
import { MarcaService } from 'src/app/services/marca.service';
import { Marca } from 'src/app/persistences/marca';

@Component({
  standalone: false,
	selector: 'app-lista-similares',
	templateUrl: './lista-similares.component.html',
	styleUrls: ['./lista-similares.component.css']
})
export class ListaSimilaresComponent implements OnInit {
	public imageObject: Array<object> = [];
	public imagensCarregadas = false;
	public similares: ItemSimilar[] = [];
	public listaSimilares = false;
	public colunas: number;
	public promocao: string;

	get validImages(): Array<any> {
		return this.imageObject.filter(img => img !== null);
	}

	@Input()
	public cdItemAtual: string;
	public cdItemCar: string;

	@Output()
	selecionado = new EventEmitter<number>();

	constructor(
		private itemService: ItemService,
		private clienteSingleton: ClienteSingletonService,
		private jwtService: JwtService,
		private currencyPipe: CurrencyPipe,
		private snackBarManager: SnackbarManager,
		private marcaService: MarcaService,
		private cdr: ChangeDetectorRef
	) {

	}

	ngOnInit(): void {
		this.colunas = (window.innerWidth <= 700) ? 1 : 4;
	}

	onResize(event) {
		const width = event.target.innerWidth;
		if (width >= 1080) {
			this.colunas = 4;
		}
		if (width < 1080 && width > 800) {
			this.colunas = 3;
		}
		if (width < 800 && width > 700) {
			this.colunas = 2;
		}
		if (width < 700) {
			this.colunas = 1;
		}
	}


	carregaSimilares(id_item: number) {
		this.imagensCarregadas = false;
		this.similares = [];
		this.imageObject = [];

		this.itemService.getSimilares(id_item).pipe(
			mergeMap((res: any[]) => {
				if (res != undefined) {
					res["itens"].forEach((item) => {
					const a = new ItemSimilar(
						undefined,
						item["idItem"],
						item["nmItem"],
						item["qtAtual"] > 0 ? item["cdItem"] : 'INDISPONÍVEL - '+item["cdItem"],
						item["qtAtual"],
						item["qtDisponivel"],
						item["estoqueDisponivel"],
						item["preco"],
						item["flPromocao"],
						item["pcMaxDescontoAut"],
						item["ipi"],
						item["st"],
						item["ipiSt"],
						item["cdMarca"]);
					this.similares.push(a);
					});
				}

				this.similares.sort((a, b) => {
					const aIndisponivel = a.cdItem.startsWith("INDISPONÍVEL");
					const bIndisponivel = b.cdItem.startsWith("INDISPONÍVEL");
					return aIndisponivel === bIndisponivel ? 0 : aIndisponivel ? 1 : -1;
				});

				this.imageObject = Array.from({ length: this.similares.length }).map(() => null);
				this.similares.forEach((s, i) => s.indice = i);

				return this.similares;
			})
		)
		.subscribe(
			(similar: ItemSimilar) => {
			let marcaSimilar = new Marca();
			this.marcaService.getMarcaById(similar.cdMarca).subscribe((marca)=> {
				marcaSimilar = marca;

				this.itemService.getImagem(similar.idItem, true).subscribe(
					(imagem: string) => {
						similar.imagem = imagem == "" ? "assets/images/sem_imagem.png" : "data:image/jpeg;base64," + imagem;
						this.promocao = similar.flPromocao ? "- PROMOÇÃO" : " ";

						const cliente: Cliente = this.clienteSingleton.getClienteEstatico();
						let valor = NumberUtils.roundTo(NumberUtils.roundTo(similar.preco,2) * (1 + cliente.getPcMarkup / 100), 2);
						valor = NumberUtils.roundTo(valor * (1 - similar.pcMaxDescontoAut / 100), 2);
						valor = NumberUtils.roundTo(valor
						+ NumberUtils.roundTo(similar.ipiSt
						* (1 + cliente.getPcMarkup / 100)
						* (1 - similar.pcMaxDescontoAut / 100), 2), 2);

						const valorString = this.currencyPipe.transform(valor,"R$");
						const title = `${similar.cdItem} - ${marcaSimilar.nmMarca} - ${valorString} ${this.promocao}`;

						const pos = similar.indice!;
						this.imageObject[pos] = {
							thumbImage: similar.imagem,
							title: title,
							index: pos
						};
						this.cdr.detectChanges();
					},
					(error) => {
						this.jwtService.validarAcessToken(error);
						this.snackBarManager.openSnackBar(error.error,"Ok",3000);
					}
				);
			});
			},
			(error) => {
			this.jwtService.validarAcessToken(error);
			this.snackBarManager.openSnackBar(error.error,"Ok",3000);
			}
		);

		this.imagensCarregadas = true;
	}


	onClickImagem(eventOrIndex: any) {
		const ind = typeof eventOrIndex === 'number' ? eventOrIndex : (eventOrIndex && eventOrIndex.index != null ? eventOrIndex.index : null);
		if (ind == null) return;

		const item = this.similares.find(i => i.indice === ind);
		if (item) {
			this.cdItemAtual = item.cdItem;
			this.selecionado.emit(item.idItem);
		}

		this.setDestaque();
	}

	setDestaque() {
		const destaque: any = document.getElementsByClassName('caption');
		for (let i = 0; i < destaque.length; i++) {
			if (destaque[i].innerHTML.split(' - ')[0] == this.cdItemAtual) {
				destaque[i].style.background = 'black';
			} else {
				destaque[i].style.background = ' linear-gradient(to right, rgba(0, 0, 0, .6), rgba(0, 0, 0, .6), rgba(0, 0, 0, .6), rgba(0, 0, 0, .6), rgba(0, 0, 0, .6))';
			}
		}
	}
}
